import { c as _c } from "react/compiler-runtime";
import { Dropdown, useToast } from '@onefootprint/ui';
import { useStore } from '@/components/playbook-builder';
import useEdit from '@/components/playbook-builder/hooks/use-edit';
import { withSubject } from '@/components/playbook-builder/utils/get-subject';
import { useClipboardNodes } from '../add-node-dialog/components/paste-node-button';
const EmployeeGraphActions = () => {
  const $ = _c(25);
  const {
    toast
  } = useToast();
  const {
    data: t0
  } = useStore();
  const {
    canEdit: editMode,
    graph,
    sessionId
  } = t0;
  const editMutation = useEdit();
  const {
    getNodesToPaste,
    displayPasteButton
  } = useClipboardNodes();
  let t1;
  if ($[0] !== editMutation || $[1] !== getNodesToPaste || $[2] !== toast) {
    t1 = async () => {
      const nodesToPaste = await getNodesToPaste();
      if (!nodesToPaste?.length) {
        toast({
          title: "Nothing to paste",
          description: "There is nothing to paste from your clipboard.",
          variant: "error"
        });
        return;
      }
      await editMutation.mutateAsync({
        kind: "replace_graph",
        data: nodesToPaste
      });
      toast({
        title: "Success!",
        description: "The graph has been replaced with the nodes from your clipboard.",
        variant: "success"
      });
    };
    $[0] = editMutation;
    $[1] = getNodesToPaste;
    $[2] = toast;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleReplaceGraph = t1;
  let t2;
  if ($[4] !== editMutation || $[5] !== toast) {
    t2 = async () => {
      try {
        await editMutation.mutateAsync({
          kind: "update_settings"
        });
        toast({
          title: "Success!",
          description: "Opened an edit session with a modernized graph. Review it before publishing."
        });
      } catch {}
    };
    $[4] = editMutation;
    $[5] = toast;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const handleModernizeGraph = t2;
  let t3;
  if ($[7] !== graph || $[8] !== toast) {
    t3 = () => {
      const nodesToCopy = graph.nodes.map(withSubject(graph));
      navigator.clipboard.writeText(JSON.stringify(nodesToCopy, null, 2));
      toast({
        title: "Copied!",
        description: "The graph's nodes have been copied to your clipboard."
      });
    };
    $[7] = graph;
    $[8] = toast;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const handleCopyNodes = t3;
  let t4;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Dropdown.GroupTitle>Employee-only actions</Dropdown.GroupTitle>;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const t5 = !editMode || !displayPasteButton || editMutation.isPending;
  let t6;
  if ($[11] !== handleReplaceGraph || $[12] !== t5) {
    t6 = <Dropdown.Item disabled={t5} onSelect={handleReplaceGraph}>Replace graph (from clipboard)</Dropdown.Item>;
    $[11] = handleReplaceGraph;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== handleCopyNodes) {
    t7 = <Dropdown.Item onSelect={handleCopyNodes}>Copy nodes</Dropdown.Item>;
    $[14] = handleCopyNodes;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== editMode || $[17] !== editMutation || $[18] !== handleModernizeGraph || $[19] !== sessionId) {
    t8 = !sessionId && <Dropdown.Item disabled={!editMode || editMutation.isPending} onSelect={handleModernizeGraph}>Modernize in edit session</Dropdown.Item>;
    $[16] = editMode;
    $[17] = editMutation;
    $[18] = handleModernizeGraph;
    $[19] = sessionId;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t6 || $[22] !== t7 || $[23] !== t8) {
    t9 = <Dropdown.Group>{t4}{t6}{t7}{t8}</Dropdown.Group>;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  return t9;
};
export default EmployeeGraphActions;